export enum COMPANY_DROPDOWN_SELECT_TYPES {
  CHANGE_DROPDOWN,
  SELECT,
}

export type CompanyDropdownData = { id: number; company_name: string };
export type ICompanyDropdownSelectEvent = {
  type: COMPANY_DROPDOWN_SELECT_TYPES;
  data?: CompanyDropdownData;
  isTemporaryContractor?: boolean;
};
